import { UserType } from "@/config";


export default [
  {
    path: '/assigned-learners',
    name: 'AssignedLearners',
    component: () => import(/* webpackChunkName: "noeticTraining" */ '@/views/NoeticTraining/AssignedLearners.vue'),
    meta:{
      appBar: "user", appClass: "appModeUser",allowedUsers: [UserType.PLAN_MANAGER]
    }  
  }
]